module.exports = __webpack_public_path__ + "static/media/11.13512df2.jpg";